<template>
  <div class="offcanvas offcanvas-end oc-bottom" data-bs-scroll="true" tabindex="-1" id="notificationTalkArea" aria-labelledby="notificationTalkAreaLabel">
    <div class="offcanvas-header notification-header bg-primary text-light form-check form-check-notification mb-0">
      <h2 class="offcanvas-title fs-5 ms-3" id="notificationTalkAreaLabel">トーク通知</h2>
      <span type="button" class="btn-close btn-close-white text-reset" data-coreui-dismiss="offcanvas" aria-label="Close"></span>
    </div>
    <notification-talk-area-body :unread-checked="unreadChecked" />
  </div>
</template>

<script>
import NotificationTalkAreaBody from '@/views/atoms/NotificationTalkAreaBody'

export default {
  name: "NotificationTalkArea",
  components: {
    NotificationTalkAreaBody,
  },
  data() {
    return {
      unreadChecked: false,
    }
  },
}
</script>

<style scoped>
  .form-check-input:checked[type=checkbox] {
    background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='rgba(1,65,77,0.87)' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>");
    background-color: white;
  }
</style>
